<template>
    <div class="home">
          <div class="box">	
              <form @submit.prevent="saveSupplier">
                      <div class="field">
                          <label class="label">Supplier Name </label>
                          <div class="control">
                              <input class="input" type="text" v-model="name" autofocus required>
                             
                          </div>
                      </div>

                      <div class="field">
                          <label class="label">Contact Name </label>
                          <div class="control">
                              <input class="input" type="text" v-model="contact_name" >
                             
                          </div>
                      </div>

                      <div class="field">
                          <label class="label">Address</label>
                          <div class="control">
                              <input class="input" type="text" v-model="address" >
                             
                          </div>
                      </div>

                      <div class="field">
                          <label class="label">Telephone </label>
                          <div class="control">
                              <input class="input" type="text" v-model="telephone" >
                             
                          </div>
                      </div>

  
                     
                      <div class="field is-grouped">
                          <div class="control">
                              <button class="button is-success" :disabled="working===true">Save Supplier</button>
                          </div>
                      </div>
                  </form>
            
          </div>
          
      </div>
  </template>

<script>
    //import AwardsMixin from '@/mixins/AwardsMixin.js';
    import StoneService from '@/services/StoneService.js';
    //import UtilityService from '@/services/UtilityService.js';
    
    export default {
      name: 'AddSupplier',
        mixins: [],
        data: function () {
            return {
                   loading : false,
                  search: "",
                    API_NAME: process.env.VUE_APP_API_NAME,
                    accessToken: '',
                    name: '',
                    contact_name: '',
                    address: '',
                    telephone: '',
                    working: false
                    
                   
            }
        },
        created() {
          this.getAccessToken()
            .then(() => { 
              
            });
          
        },
        methods: {
            
            async saveSupplier() {
                this.working = true
                var formdata = { 
                    name : this.name,
                    contact_name : this.contact_name,
                    address : this.address,
                    telephone : this.telephone,
                    
                }; 

                StoneService.saveSupplier(this.accessToken, formdata)
                .then((response) => {
                    this.$router.push("/suppliers");
                    console.log(response)
                    
                    }).catch((error) => {
                        if(error.response.status === 422)
                        {
                            console.log("Error:" + JSON.stringify(error.response.data));
                        }
                        alert("Something went wrong. Make sure you have filled in all the fields. \nOr ring David !!")
                        this.working = false
                });
            },
           
        }
    }
    </script>